var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"table-sortable"}),_vm._v(" "),_c('div',{staticClass:"table-cell"},[_c('user-image',{attrs:{"image":_vm.rowData.image,"color":_vm.rowData.color}}),_vm._v(" "),_c('div',{staticClass:"table-cell-name"},[_vm._v("\n            "+_vm._s(_vm.rowData.name)+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-164f08b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Organization/Settings/Employees/EmployeeCell.vue
// module id = BJGe
// module chunks = 1